import { EventEmitter } from '@angular/core';
import { BsDatepickerInlineContainerComponent, BsDatepickerInlineDirective } from 'ngx-bootstrap/datepicker';

export function getDatePickerComponentOnShown$(datePicker: BsDatepickerInlineDirective) {
    return (datePicker as any)._datepicker.onShown as EventEmitter<BsDatepickerInlineContainerComponent>;
}
